import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'

export function Details({ children, ...styleProps }) {
  return (
    <Box
      as='dl'
      display='flex'
      flexDirection='row'
      flexWrap='wrap'
      marginRight='spacePaddingLarge'
      {...styleProps}
    >
      {children}
    </Box>
  )
}

Details.propTypes = {
  children: PropTypes.node,
}

export function Term({ children, ...styleProps }) {
  return (
    <Box
      as='dt'
      margin='0'
      flex='1 1 180px'
      paddingRight='spacePaddingXLarge'
      color='colorTextDeemphasis'
      fontSize='14px'
      marginTop='spacePaddingXLarge'
      {...styleProps}
    >
      {children}
    </Box>
  )
}

Term.propTypes = {
  children: PropTypes.node,
}

export function Definition({ children, ...styleProps }) {
  return (
    <Box
      as='dd'
      margin='0'
      flex='1 1 calc(100% - 180px)'
      paddingRight='spacePaddingXLarge'
      fontSize='14px'
      wordWrap='break-word'
      wordBreak='break-word'
      hyphens='auto'
      marginTop='spacePaddingXLarge'
      {...styleProps}
    >
      {children}
    </Box>
  )
}

Definition.propTypes = {
  children: PropTypes.node,
}
